// extracted by mini-css-extract-plugin
export default {"categoriesLine":"servory_categoriesLine__0j4uC","formQuestion":"servory_formQuestion__oJQKY"};